// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2Vx2v","messages":"Chat_messages__3oI59","dateDivider":"Chat_dateDivider__1uk7J"};